import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {NON_NATIONAL_APPLICATION_STATUS_DROPDOWN} from '../../constants/apiUrls';
import {NON_NATIONAL_APPLICATION_STATUS_DROPDOWN_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface NonNationalApplicationStatusDropdownResponse {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  allStatus?: boolean;
  onSuccess?: (data: NonNationalApplicationStatusDropdownResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalApplicationStatusDropdown = ({
                                                             allStatus = false,
                                                             onSuccess,
                                                             onError,
                                                           }: Input) => {
  const getNonNationalApplicationStatusDropdown = async () => {
    const res = await axiosClient.get<NonNationalApplicationStatusDropdownResponse[]>(
        NON_NATIONAL_APPLICATION_STATUS_DROPDOWN(allStatus)
    );
    return res.data;
  };
  return useCustomQuery(
      [NON_NATIONAL_APPLICATION_STATUS_DROPDOWN_QUERY_KEY],
      getNonNationalApplicationStatusDropdown,
      {
        onSuccess,
        onError,
      }
  );
};
